/**
 * Shared head() builder for utility pages that must NOT be indexed:
 * auth flows (login/signup/password) and post-conversion confirmation
 * pages. These are thin, duplicate, or session-specific, so we serve a
 * server-rendered `noindex, follow` robots tag plus a self-referencing
 * canonical instead of falling back to the generic homepage title.
 */

import { brand } from "@/config/brand";
const SITE_URL = brand.url;

export function buildNoindexHead(title: string, path: string) {
  const fullTitle = `${title} — Digitally Baffled`;
  const canonicalUrl = `${SITE_URL}${path}`;
  return {
    meta: [
      { title: fullTitle },
      { name: "robots", content: "noindex, follow" },
      { property: "og:title", content: fullTitle },
      { property: "og:url", content: canonicalUrl },
    ],
    links: [{ rel: "canonical", href: canonicalUrl }],
  };
}
